/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NameChangeRequest
 */
export interface NameChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof NameChangeRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NameChangeRequest
     */
    surName?: string | null;
}

/**
 * Check if a given object implements the NameChangeRequest interface.
 */
export function instanceOfNameChangeRequest(value: object): value is NameChangeRequest {
    return true;
}

export function NameChangeRequestFromJSON(json: any): NameChangeRequest {
    return NameChangeRequestFromJSONTyped(json, false);
}

export function NameChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NameChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surName': json['surName'] === undefined ? undefined : json['surName'] === null ? null : json['surName'],
    };
}

export function NameChangeRequestToJSON(json: any): NameChangeRequest {
    return NameChangeRequestToJSONTyped(json, false);
}

export function NameChangeRequestToJSONTyped(value?: NameChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'surName': value['surName'],
    };
}

